import * as React from "react";
import { LoaderFunctionArgs, redirect, useLocation } from "react-router-dom";
import { LoanHistoryView } from "@tlc/ls2pac/app/views/myAccountViews/accountActivitySubViews/LoanHistoryView";
import { useAccount } from "../../Account";
import { SupportedFunctionalityHolder } from "../../SupportedFunctionality";
import useBackToLink from "../resource/useBackToLink";
import { useLanguage } from "../../Language";

export async function loanHistoryLoader({ request }: LoaderFunctionArgs) {
  console.log("loanHistoryLoader executing");

  const supportedFunctionality = await SupportedFunctionalityHolder.fetchData();

  if (supportedFunctionality.supportsLoanHistory === false) {
    return redirect("/myaccount/summary");
  }

  return {};
}

export const AccountHistoryPage: React.FC = () => {
  const { accountSummary, user, patron } = useAccount();
  const { translate } = useLanguage();
  const location = useLocation();
  useBackToLink(translate("loanHistory"), location);
  // const {accountSummary, user, patron} = useRouteLoaderData("myaccount") as LoaderData<typeof myAccountLoader>;

  React.useEffect(() => {
    const view = new LoanHistoryView();
    view.load(
      { accountSummary, patron },
      user,
      document.getElementById("loanHistoryContainer"),
      "loanHistory"
    );

    return () => {
      view?.cleanup();
    };
  }, []);

  return <div id="loanHistoryContainer"></div>;
};
